import Loading from "@/components/loading/loading.vue";
import { FocusWordsAssociationLocale } from "@/locales/localeid";
import TitleListState from "@/modules/title-list";
import UnitState from "@/modules/unit";
import { VersionGroupModule } from "@/modules/versiongroup";
import { FocusWordsAssociationService, IFocusWordsAssociationService } from "@/services/focus-words-associate";
import { disabledDueToAccessLevel, getRouteAccessLevel } from "@/util/func";
import { Alert, Button, Checkbox, Col, Empty, Input, Modal, Radio, Row, Select, Table } from "ant-design-vue";
import { ActionItem, fmtMsg } from "commonui";
import { cloneDeep } from "lodash";
import { Component, Vue, Watch } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";

@Component({
	components: {
		Table,
		Row,
		Col,
		Select,
		Option: Select.Option,
		Button,
		ActionItem,
		Alert,
		Checkbox,
		CheckboxGroup: Checkbox.Group,
		Loading,
		Modal,
		Empty
	}
})
export default class FocusWords extends Vue {
	allFocusWords: any[] = [];
	selectedFocusWords: any[] = [];
	selectedFocusWordsCopy: any[] = [];
	updatedFocusWords: any[] = [];
	focusWordsAssociationService: IFocusWordsAssociationService = FocusWordsAssociationService();

	public versionGroupModule = VersionGroupModule;
	public titleListModule = getModule(TitleListState);
	public unitModule = getModule(UnitState);
	public isLoading: boolean = false;
	public isDirty: boolean = false;
	public isModalVisible: boolean = false;
	public focusWordsList: any[] = [];
	public chapterNameList: any[] = [];
	public str: any = "";

	public locale = FocusWordsAssociationLocale;

	public columns: any[] = [
		{
			title: fmtMsg(this.locale.TableColumnHeadingWord),
			dataIndex: "word",
			key: "word",
			width: "50%"
		},
		{
			title: fmtMsg(this.locale.TableColumnHeadingChapter),
			dataIndex: "chapter",
			key: "chapter",
			width: "50%"
		}
	];

	get currentRouteAccessLevel() {
		return getRouteAccessLevel(this.$route);
	}

	get disabledDueToAccessLevel() {
		return disabledDueToAccessLevel(this.currentRouteAccessLevel);
	}

	@Watch("titleListModule.updatedDetails.vcsLevelId", { immediate: true, deep: true })
	@Watch("titleListModule.getEditedContentDetails.id", { immediate: true, deep: true })
	getFocusWords() {
		if (!this.titleListModule.updatedDetails.vcsLevelId) {
			return;
		}

		this.isLoading = true;

		const params = {
			parentId: this.titleListModule.getEditedContentDetails.id,
			gsVersionGroupId: this.versionGroupModule.selectedGsVersion,
			lsVersionGroupId: this.versionGroupModule.selectedLsVersion,
			chapterId: this.getChapterId()
		};

		const routeData = { unitId: this.titleListModule.updatedDetails.vcsLevelId };

		this.focusWordsAssociationService
			.getFocusWordsByChapterId(params, routeData)
			.then((res) => {
				this.allFocusWords = res.focusWords;
				this.selectedFocusWords = res.selectedFocusWords.map((word) => word.focusWordId);
				this.selectedFocusWordsCopy = cloneDeep(this.selectedFocusWords);
				this.isLoading = false;
			})
			.catch((err) => {
				this.isLoading = false;
			});
	}

	updateFocusWords() {
		this.isLoading = true;

		const params = {
			contentId: this.getSelectedComponentId(),
			updatedFocusWordsAssociations: this.updatedFocusWords,
			isChapterFocusWord: !!this.getChapterId()
		};

		this.focusWordsAssociationService
			.updateFocusWords(params)
			.then((res) => {
				this.isLoading = false;
				this.getFocusWords();
			})
			.catch((err) => {
				this.str = err.error_description[0];
				this.str = this.str.replace("Error:", " ");
				this.str = JSON.parse(this.str);

				this.str.forEach((ele: any) => {
					this.focusWordsList.push(ele.FocusWordText);
					this.chapterNameList.push(ele.ChapterName);
				});

				this.selectedFocusWords = this.selectedFocusWordsCopy;
				this.isLoading = false;
				this.isModalVisible = true;
			});
	}

	onModalOk() {
		this.isModalVisible = false;
		this.focusWordsList = [];
	}

	getLinkMessage(ele, index) {
		return this.chapterNameList[index];
	}

	getParentId() {
		if (
			this.titleListModule.editeContentSelectedChapterId == "all" ||
			this.titleListModule.editeContentSelectedChapterId == "none"
		) {
			return this.titleListModule.editedContentDetails.id;
		}
		return null;
	}

	getSelectedComponentId() {
		return this.getParentId() || this.getChapterId();
	}

	getChapterId() {
		if (
			this.titleListModule.editeContentSelectedChapterId == "all" ||
			this.titleListModule.editeContentSelectedChapterId == "none"
		) {
			return null;
		}
		return this.titleListModule.editeContentSelectedChapterId;
	}

	onComponentChange(values: any) {
		this.isDirty = true;
		this.selectedFocusWords = values;
		this.updatedFocusWords = values;
	}

	get disableSave() {
		return !this.isDirty;
	}

	onSave() {
		this.isDirty = false;
		this.updateFocusWords();
	}
}
